// import axios from 'axios'
const axios = require('axios')

export default function () {
  this.http = axios.create({
    //  baseURL:location.port == '8080'?location.protocol+'//'+location.host+'/api1':"../../",
   baseURL:location.port == '8080'?location.protocol+'//'+location.host+'/api1':"https://api.jiaodong.net/ytgdzk/zkadm/index.php",
    withCredentials: false,
    // crossDomain: true,
    // timeout: 30000
  });


  this.loading = function (vm, loadingOptions) {
    this.loadingService = vm.$loading;
    this.router = vm.$router;
    this.store = vm.$store;
    this.loadingOptions = loadingOptions;

    var axiosRequestInterceptor = this.http.interceptors.request.use(function (config) {
      if (this.loadingService) {
        let options = this.loadingOptions;
        if (!options) {
          options = {fullscreen: true};
        } else {
          this.loadingOptions = undefined;
        }
        this.loadingInstance = this.loadingService(options);
        this.loadingService = null;
      }
      return config;
    }.bind(this), function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    }.bind(this));
    var axiosResponseInterceptor = this.http.interceptors.response.use(function (response) {
      this.loadingInstance && this.loadingInstance.close();
      if(response.data.data == 'TIMEOUT' && !response.data.success && !response.config.url.endsWith('/check')){
        this.router.replace({name:'Login'});
      }else{
        return response;
      }

    }.bind(this), function (error) {
      // 对响应错误做点什么
      this.loadingInstance && this.loadingInstance.close();
      return Promise.reject(error);
    }.bind(this));

    return this;
  };
  this.post = function (url, data, config) {
    let AUTH_TOKEN = localStorage.getItem("token5");
    if(AUTH_TOKEN&&AUTH_TOKEN!=''&&AUTH_TOKEN!=null){
      this.http.defaults.headers.common["Authorization"] = AUTH_TOKEN;
    }
    var ennPromise = {};
    ennPromise.promise = this.http.post(url, data, config);
    ennPromise.loadingInstance = this.loadingInstance;

    ennPromise.then = function (successFunction) {
      this.promise = this.promise.then(function (resp) {
        if (resp) {
          successFunction(resp);
        }

      }.bind(this));
      return this;
    };
    ennPromise.catch = function (errFunction) {
      this.promise = this.promise.catch(function (err) {
        console && console.log(JSON.stringify(err.response));
        errFunction(err);
      }.bind(this));
      return this;
    };
    return ennPromise;
  };

  this.transformRequest = function (url,data) {
    let newData = '?';
    for (let k in data) {
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return url+newData.substring(0,newData.length-1);
  };

  this.get = function (url, params, config) {
    let AUTH_TOKEN = localStorage.getItem("token5");
    if(AUTH_TOKEN&&AUTH_TOKEN!=''&&AUTH_TOKEN!=null){
      this.http.defaults.headers.common["Authorization"] = AUTH_TOKEN;
    }
    var ennPromise = {};
    ennPromise.promise = this.http.get(this.transformRequest(url,params),config);
    ennPromise.loadingInstance = this.loadingInstance;
    ennPromise.then = function (successFunction) {
      this.promise = this.promise.then(function (resp) {
        if (resp) {
          successFunction(resp);
        }

      }.bind(this));
      return this;
    };
    ennPromise.catch = function (errFunction) {
      this.promise = this.promise.catch(function (err) {
        console && console.log(JSON.stringify(err.response));
        errFunction(err);
      }.bind(this));
      return this;
    };
    return ennPromise;
  };

};
